<template>
<div id="appdettaglio" v-cloak>

    <b-container fluid>
        <b-row>
            <b-col sm="12" md="8" lg="6" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
                <b-card :header="(this.$route.params.id != null ? 'Documento #' + this.$route.params.id : 'Nuovo documento')">

                    <b-container fluid class="mx-auto text-left" v-if="(this.$route.params.id == null && this.$route.params.id_socio == null) || (this.$route.params.id != null && showdettaglio1) || (this.$route.params.id_socio != null && showdettaglio2)">
                         <b-row class="my-1">
                                <b-col sm="3"><label for="coso">Cognome socio:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="documento.cognomesocio" id="coso" type="text" disabled></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="noso">Nome socio:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="documento.nomesocio" id="noso" type="text" disabled></b-form-input>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="descrizione">Descrizione:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-textarea id="descrizione" v-model="documento.descrizione" :rows="2"></b-form-textarea>
                                    </b-col>
                                </b-row>                                                                
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="note">Note:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-textarea id="note" v-model="documento.note" :rows="3"></b-form-textarea>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="tipo">Tipo documento:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-select v-model="documento.tipo" :options="options_tipo" id="tipo">

                                        </b-form-select>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="datainizio">Data inizio:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="documento.datainizio" id="datainizio" type="date"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="datafine">Data fine:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="documento.datafine" id="datafine" type="date"></b-form-input>
                                    </b-col>
                                </b-row> 
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="flagatt">Stato:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-select v-model="documento.flagsta" :options="options_stati" id="flagsta">

                                        </b-form-select>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1" v-if="documento.id != null" >
                                    <b-col sm="3"><label for="uteins">Allegato:</label></b-col>
                                    <b-col sm="6">
                                        <b-form-input v-model="documento.allegatoVis" id="allegatoVis" type="text" disabled></b-form-input>
                                    </b-col>
                                    <b-col sm="3">
                                        <b-btn style="margin:0px 0px 1px 2px;" variant="info" size="sm" @click.stop="insAllegato()">Inserisci</b-btn>
                                        <b-btn v-if="documento.idallegato != ''" style="margin:0px 0px 1px 2px;" size="sm" @click.stop="details()">Visualizza</b-btn>
                                    </b-col>    
                                </b-row>
                                <b-row class="my-1" v-if="documento.id != null">
                                    <b-col sm="3"><label for="datains">Data inserimento:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="documento.datains" id="datains" type="text" disabled></b-form-input>
                                    </b-col>
                                </b-row>                                
                                <b-row class="my-1" v-if="documento.id != null">
                                    <b-col sm="3"><label for="uteins">Utente inserimento:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="documento.uteins" id="uteins" type="text" disabled></b-form-input>
                                    </b-col>
                                </b-row>                                

                                <b-row class="my-3">

                                    <b-col sm="5" offset-sm="3">
                                        <b-button block size="md" variant="outline-primary" v-on:click="insert()">
                                            <div v-if="documento.id != null">
                                                Salva
                                            </div>
                                            <div v-else>
                                                Inserisci
                                            </div>                                            
                                        </b-button>
                                    </b-col>
                                    <b-col sm="4">
                                        <b-button v-if="this.$route.params.id_socio == null" block size="md" variant="outline-secondary" v-on:click="selSocio()">
                                            Seleziona socio
                                        </b-button>
                                    </b-col>
                                </b-row>
                    </b-container>

                    <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>
                    <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountdown=0" @dismiss-count-down="countDownChanged">
                        Operazione effettuata con successo
                    </b-alert>


                </b-card>
            </b-col>
        </b-row>
    </b-container>

    <!-- Modal Component Upload -->
    <b-modal v-model="uploadModal.show" title="Seleziona il file da inserire" @hidden="onHidden">
        <!-- <p class="my-2">Seleziona il file da inserire</p> -->
        <b-btn id="browse" ref="browse" size="md" variant="primary">Sfoglia...</b-btn>
        <h5>{{uploadModal.descrCaricamento}}</h5>
        <b-progress v-if="uploadModal.showPercent" :value="uploadModal.percentCaricamento" :max="100" show-progress animated></b-progress>
        <b-alert style="margin-top:10px;" :show="(uploadModal.errorCaricamento != '')" variant="danger">{{ uploadModal.errorCaricamento }}</b-alert>
        <div slot="modal-footer" class="w-100">
            <b-btn size="sm" class="float-right" variant="primary" @click="caricaItem()" style="margin: 2px;">
                Inserisci
            </b-btn>
            <b-btn size="sm" class="float-right" variant="secondary" @click="uploadModal.show=false" style="margin: 2px;">
                Annulla
            </b-btn>
        </div>
    </b-modal>

    <!-- Modal Component -->
    <b-modal size="lg" v-model="sociModal.show" title="Seleziona il socio">
        <!-- <p class="my-2">Seleziona il socio</p> -->

        <div class="text-left">
            <div class="my-1 row">
                <div class="col-md-3">
                    <b-form-input v-model="sociModal.filter" placeholder="Cerca..." />
                </div>
            </div>

            <!-- Main table element -->
            <b-table responsive small id="main-table" striped hover show-empty :items="sociModal.items" :fields="sociModal.fields" :current-page="sociModal.currentPage" :per-page="sociModal.perPage" :filter="sociModal.filter" :sort-by.sync="sociModal.sortBy" :sort-desc.sync="sociModal.sortDesc"
                @filtered="onFiltered">
                <template slot="id" scope="row">{{row.value}}</template>
                <template slot="cognomesocio" scope="row">{{row.value}}</template>
                <template slot="nomesocio" scope="row">{{row.value}}</template>
                <!-- <template slot="matricola" scope="row">{{row.value}}</template> -->
                <template slot="email" scope="row">{{row.value}}</template>
                <template slot="seleziona" scope="row">
                <!-- We use click.stop here to prevent a 'row-clicked' event from also happening -->
                <b-btn size="sm" variant="danger" @click.stop="seleziona(row.item,row.index,$event.target)">Seleziona</b-btn>
            </template>
            </b-table>

            <div class="row my-1">
                <div class="col-md-7 col-sm-12">
                    <b-pagination :total-rows="totalRows" :per-page="sociModal.perPage" v-model="sociModal.currentPage" />
                </div>
                <div class="col-md-5 col-sm-12 text-right">
                    <b-form-fieldset horizontal label="Righe per pagina" :label-cols="6">
                        <b-form-select :options="sociModal.pageOptions" v-model="sociModal.perPage" />
                    </b-form-fieldset>
                </div>
            </div>
        </div>

        <div slot="modal-footer" class="w-100">
            <b-btn size="sm" class="float-right" variant="secondary" @click="sociModal.show=false" style="margin: 2px;">
                Chiudi
            </b-btn>
        </div>
    </b-modal>


</div>
</template>

<script>

import {
    NAMESPACE,
    TOKENUPLOAD
} from '../config.js'

import {
    Documento,
    Visibilità
} from '../classes.js'

import {
    uuidv4
} from '../util.js'

import {
    ctrlVismenu
} from '../util.js'

import {
    Resumable
} from '../resumable.js'

export default {    
    name: 'appdettaglio',
    
    data: function () {
        return {                       
            namespace: NAMESPACE,            
            r: new Resumable({
                target: '',
                testChunks: true
            }),
            documento: {
                id: this.$route.params.id || null,
                datains: null,
                uteins: '',
                nomesocio: '',
                cognomesocio: '',                
                descrizione: '',
                note: '',
                tipo: '',
                flagsta: 'I',  
                allegato: '',
                allegatoVis: '',
                idallegato: '',
                id_socio: this.$route.params.id_socio,
                datainizio: '', 
                datafine: ''
            },           
            //id_socio: this.$route.params.id_socio,
            options_tipo: [],
            options_stati: [],   
            error: '',
            showerror: false,
            showdettaglio1: false,
            showdettaglio2: false,
            dismissSecs: 5,
            dismissCountDown: 0,
            uploadModal: {
                show: false,
                descrCaricamento: '',
                showPercent: false,
                percentCaricamento: 0,
                errorCaricamento: '',
                uuidv4: ''
            },
            sociModal: {
                show: false,
                items: [],
                fields: {
                    id: {
                        label: '#',
                        sortable: true
                    },
                    cognome: {
                        label: 'Cognome',
                        sortable: true
                    },
                    nome: {
                        label: 'Nome',
                        sortable: true
                    },
                    /* 
                                        account: {
                                            label: 'Matricola',
                                            sortable: true
                                        }, */
                    email: {
                        label: 'Email',
                        sortable: true
                    },
                    seleziona: {
                        label: ' ',
                        'class': 'text-right'
                    }
                },
                currentPage: 1,
                perPage: 5,
                pageOptions: [{
                    text: 5,
                    value: 5
                }, {
                    text: 10,
                    value: 10
                }, {
                    text: 15,
                    value: 15
                }],
                sortBy: null,
                sortDesc: false,
                filter: null,     
                totalRowsFilter: null,
            }       
        };
    },
    computed: {
        totalRows: {
            // getter
            get: function () {
                return this.sociModal.totalRowsFilter || this.sociModal.items.length || 0;
            },
            // setter
            set: function (newValue) {
                this.sociModal.totalRowsFilter = newValue;
            }
        }

    },
    methods: {
        caricaDati(id){
            
            var appdettaglio = this;
            this.options_tipo = this.getTipi();

            var id = this.documento.id; //se è la prima volta si prova a prendere da getid 

            

            if (id != null) {

                var token = localStorage.getItem('token');                

                this.axios.get(NAMESPACE + 'rest/documenti/' + id, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;
                                if (res.length > 0) {
                                    this.documento = res[0];
                                    this.documento.nomesocio = res[0].nomesocio;
                                    this.documento.cognomesocio = res[0].cognomesocio;

                                    if((res[0].allegato || "") != ""){
                                        var split = res[0].allegato.split('/');
                                        this.documento.allegatoVis = decodeURI(split[split.length - 1]);
                                    }

                                    this.showdettaglio1 = true;

                                } else {
                                    throw new Error("Errore dati non trovati!");
                                }


                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            appdettaglio.showerror = true;
                            appdettaglio.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });            
            }
            else if(this.documento.id_socio != null){

                var token = localStorage.getItem('token');

                this.axios.get(NAMESPACE + 'rest/soci/' + this.documento.id_socio, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            var res = response.data.message;
                            if (res.length > 0) {     

                                this.documento.nomesocio = res[0].nome;
                                this.documento.cognomesocio = res[0].cognome;
                                this.showdettaglio2 = true;

                            } else {
                                throw new Error("Errore dati socio non trovati!");
                            }


                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

            }
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        },
        onHidden(evt) {
            this.r.cancel();
        },
        getTipi() {

            var dc = new Documento();
            var tipi = dc.getListaTipi();
            var keys = Object.keys(tipi);
            var options = [];
            for (var i = 0; i < keys.length; i++) {
                options.push({
                    value: keys[i],
                    text: tipi[keys[i]]
                });
            }

            return options;

        },        
        seleziona(item, index, button) {
            this.documento.id_socio = item.id;
            //alert(this.documento.id_socio);
            this.documento.nomesocio = item.nome;
            this.documento.cognomesocio = item.cognome;
            this.sociModal.show = false
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.sociModal.totalRows = filteredItems.length;
            this.sociModal.currentPage = 1;
        },
        details() {
            window.open(this.documento.allegato, '_blank');
        },        
        selSocio() {
                
            var token = localStorage.getItem('token');
            this.axios.get(NAMESPACE + 'rest/soci', {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            this.sociModal.items = response.data.message;
                            this.sociModal.items.forEach(function(element, index) {
                                delete element.uteins; //per motivi di ricerca
                            });
                            this.sociModal.show = true;

                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {
                        this.sociModal.showerror = true;
                        this.sociModal.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    this.sociModal.showerror = true;
                    this.sociModal.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

        },
        insAllegato() {

            this.uploadModal.showPercent = false;
            this.uploadModal.descrCaricamento = '';
            this.uploadModal.percentCaricamento = 0;
            this.uploadModal.errorCaricamento = '';
            this.uploadModal.show = true;
            this.uploadModal.uuidv4 = uuidv4();

            this.$nextTick(() => {
                this.prepareUpload();
            });

        },
        caricaItem() {
            if (this.r.files.length == 0) {
                alert("Nessun file selezionato!");
            } else {
                this.r.opts.target = NAMESPACE + 'rest/upload.php?id=' + this.uploadModal.uuidv4 + '&tokenupload=' + TOKENUPLOAD;
                this.uploadModal.showPercent = true;
                this.r.upload();
            }
        },
        allegatiImmagini() {

            this.$router.push({
                path: `/app/allegati/id/${this.documento.id}/tipo/D`
            });

        },

        insert() {

            var appdettaglio = this;

            if (this.documento.nomesocio == "" && this.documento.cognomesocio == "") {
                appdettaglio.showerror = true;
                appdettaglio.error = "Selezionare un socio!";

            } else if (this.documento.descrizione == "") {
                appdettaglio.showerror = true;
                appdettaglio.error = "Campo descrizione vuoto!";

            } else if (this.documento.datainizio == "" || this.documento.datainizio == null) {
                appdettaglio.showerror = true;
                appdettaglio.error = "Campo data inizio vuoto!";

            } else if (this.documento.datafine == "" || this.documento.datafine == null) {
                appdettaglio.showerror = true;
                appdettaglio.error = "Campo data fine vuoto!";

            } else if (this.documento.datafine < this.documento.datainizio) { //sono stringhe yyyy-mm-dd
                appdettaglio.showerror = true;
                appdettaglio.error = "Data inizio maggiore di data fine!";

            } else if (this.documento.tipo == null || this.documento.tipo == "") {
                appdettaglio.showerror = true;
                appdettaglio.error = "Tipo non selezionato!";
            
            // } else if (this.documento.idallegato == '' || this.documento.tipo == null) {
            //     appdettaglio.showerror = true;
            //     appdettaglio.error = "Allegato non selezionato!";

            } else {

                var json = JSON.stringify(this.documento);

                var token = localStorage.getItem('token');
                this.axios.post(NAMESPACE + 'rest/documento', json, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;                                
                                if (res.length > 0) {

                                    this.documento = res[0];
                                    this.documento.nomesocio = res[0].nomesocio;
                                    this.documento.cognomesocio = res[0].cognomesocio;

                                    if((res[0].allegato || "") != ""){
                                        var split = res[0].allegato.split('/');
                                        this.documento.allegatoVis = decodeURI(split[split.length - 1]);
                                    }
                                
                                    this.showerror = false;
                                    this.showdettaglio1 = this.showdettaglio2 = true; //anche se non dovrebbe servire                                 
                                    this.dismissCountDown = this.dismissSecs;

                                    this.$router.replace('/app/dettagliodocumento/' + this.documento.id);

                                    //this.$route.params.id = this.documento.id;

                                } else {
                                    throw new Error("Errore dati non trovati!");
                                }


                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            this.showerror = true;
                            this.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        this.showerror = true;
                        this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });

            }

        },
        prepareUpload(){

            //non rimuovere serve per resettare l'oggetto a ogni caricamento
            //altrimenti carica i file duplicandoli
            this.r = new Resumable({
                target: '',
                testChunks: true
            });

            this.r.assignBrowse(this.$refs.browse, false);

            var rg = this.r;
            var appdettaglio = this;

            this.r.on('fileAdded', function(file, event) {
                rg.files = rg.files.slice(-1); //prendo sempre solo l'ultimo file                   

                //ATTENZIONE: non cambiare è come se fosse una funzione esterna e quindi il this qui non funzionerebbe
                appdettaglio.uploadModal.descrCaricamento = file.fileName;

            });

            this.r.on('fileSuccess', function(file, message) {
                try {
                    
                    //console.log("fileSuccess" + message.trim())

                    var res = JSON.parse(message.trim());

                    if (!res.error) {
                        appdettaglio.uploadModal.percentCaricamento = 100;
                        var json = JSON.stringify({
                            'id': null,
                            'id_scheda': appdettaglio.documento.id,
                            'tipo': 'D',
                            's3': res.message.s3,
                            'allegato': encodeURI(appdettaglio.uploadModal.uuidv4 + '/' + file.fileName)
                        });

                        var token = localStorage.getItem('token');
                        appdettaglio.axios.post(NAMESPACE + 'rest/allegato', json, {
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': token
                                }
                            })
                            .then(response => {

                                // JSON responses are automatically parsed.
                                try {

                                    if (!response.data.error) {

                                        if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                        appdettaglio.caricaDati(appdettaglio.documento.id);
                                        setTimeout(function() {
                                            appdettaglio.uploadModal.show = false;
                                        }, 1000);

                                    } else {
                                        throw new Error(response.data.message);
                                    }


                                } catch (e) {
                                    throw new Error(e.message);
                                }

                            })
                            .catch(e => {
                                throw new Error((e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message));
                            });




                    } else {
                        throw new Error(res.message);
                    }

                } catch (e) {
                    appdettaglio.uploadModal.errorCaricamento = "Errore: " + e.message;
                }

            });

            this.r.on('progress', function() {
                appdettaglio.uploadModal.percentCaricamento = rg.progress() * 100;
                //alert("Perc car " + appdettaglio.uploadModal.percentCaricamento);
                //FORZATURA NON BELLA
                if (rg.progress() * 100 === 100) {
                    setTimeout(function() {
                        appdettaglio.uploadModal.show = false;
                    }, 1000);
                }


            });

            this.r.on('error', function(message, file) {
                appdettaglio.uploadModal.errorCaricamento = message;
                //alert("Errore message " + message);
                //alert("Errore file " + file);
            });



        }


    },
    created: function () {        

        if(!ctrlVismenu("D")){
            this.$router.replace('/accessdenied');
            return;
        }

        var doc = new Documento();
        var options = [];
        var listaStati = Object.keys(doc.getListaStati());
        for (var i = 0; i < listaStati.length; i++) {
            options.push({
                value: listaStati[i],
                text: doc.getStatoByFlag(listaStati[i])
            });
        }
        this.options_stati = options;

        this.caricaDati(this.id);
           
    },
    mounted: function() {
              
    }

}
</script>
